<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-06-15 08:37:16
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-06-15 08:38:51
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/home/dashboard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <Dashboard v-if="!isPur"></Dashboard>
    <Workbench v-if="isPur" /></Workbench>
  </div>
</template>

<script>
import Dashboard from './dashboardHome.vue';
import Workbench from './workbench/index';
export default {
  components: {
    Dashboard,
    Workbench,
  },
  data() {
    return {
      userInfo: {},
    };
  },
  computed: {
    isPur() {
      let userInfo = this.$store.state.USERINFO || {};
      if (userInfo?.purchaseAreaFlag && userInfo?.purchaseAreaCompanyId === userInfo?.companyId) {
        return true;
      }
      return false;
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
